import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

const ConfirmMailBusiness = () => {
  //meta title
  document.title = "Confirmation Mail | Ditobanx";
  const location = useLocation();
  const { email, businessName } = location.state || {};

  useEffect(() => {
    console.log(email, businessName);
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={7}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>¡Solicitud enviada!</h4>
                        <p className="text-muted">
                          Gracias por completar el proceso de registro{" "}
                          <span style={{ color: "blue" }}>{businessName}</span>.
                          Su solicitud será revisada por nuestro equipo.
                        </p>
                        <div
                          style={{
                            backgroundColor: "#f7f7f7",
                            padding: "10px 20px",
                            borderRadius: "10px",
                          }}
                        >
                          <h5>Próximos pasos:</h5>
                          <ul className="text-start">
                            <li>Revisión inicial de la documentación</li>
                            <li>Posible solicitud de documentos adicionales</li>
                            <li>Verificación final y aprobación</li>
                            <li>Activación de la cuenta</li>
                          </ul>
                        </div>

                        <p>Enviaremos actualizaciones al correo</p>
                        <p style={{ color: "blue" }}>{email}</p>
                        <p className="mb-3">
                          Si tiene alguna pregunta, no dude en contactar a
                          nuestro equipo de soporte.
                        </p>
                        <div className="mt-4">
                          <Link to="/login" className="btn btn-success">
                            Volver al inicio
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConfirmMailBusiness;
